import styles from './ContainerBloc.module.scss';
import { useEffect, useRef, useState } from 'react';
import invariant from 'tiny-invariant';
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { setCustomNativeDragPreview } from '@atlaskit/pragmatic-drag-and-drop/element/set-custom-native-drag-preview';
import Divider from '../Divider/DividerComponent';
import Bloc from '../Bloc/BlocComponent';
import { createPortal } from 'react-dom';

export default function ContainerBlocComponent({ blocRedlUid, blocIdx, ultimBloc, stylesBloc, children }) {
    const dragHandleRef = useRef(null);
    const [dragging, setDragging] = useState(false);
    const [preview, setPreview] = useState();

    useEffect(() => {
        const dragHandle = dragHandleRef.current;
        invariant(dragHandle);

        return draggable({
            element: dragHandle,
            getInitialData: () => ({ blocIdx, type: 'block' }),
            onGenerateDragPreview({ nativeSetDragImage }) {
                setCustomNativeDragPreview({
                    nativeSetDragImage,
                    render({ container }) {
                        setPreview(container);
                        return () => {
                            setPreview(null);
                        };
                    }
                });
            },
            onDragStart: () => setDragging(true),
            onDrop: () => setDragging(false)
        });
    }, [blocIdx]);

    return (
        <>
            <div className={styles.redlContainerBloc}>
                <Divider blocIdx={blocIdx} size="lg" />
                <div id={blocRedlUid} className={`${stylesBloc} ${dragging && styles.hideBlocStyles}`}>
                    <Bloc blocIdx={blocIdx} last={ultimBloc} ref={dragHandleRef}>
                        {children}
                    </Bloc>
                </div>
            </div>
            {preview && createPortal(<div className={styles.redlContainerBlocDragged}>
                <div>{blocIdx}</div>
            </div>, preview)}
        </>

    );
}